import { Icon, Button, Box } from '@chakra-ui/react';
import { Plus } from '@kula-ai/icons/outline/Plus';
import { KText } from '../ui-library/components/text';

export const NoDataFound = ({
  noDataIcon = null,
  label = 'No data found',
  subLabel = '',
  buttonLabel = '',
  btnOnClick = () => {},
  containerProps = {},
}) => {
  return (
    <Box
      margin={'0 auto'}
      display="flex"
      flexDirection="column"
      alignItems={'center'}
      textAlign="center"
      {...containerProps}
    >
      {noDataIcon && (
        <Icon margin={'0 auto'} as={noDataIcon} w="48px" h="48px" />
      )}
      <KText size="sm-semi-bold" mb={'10px'}>
        {label}
      </KText>
      {subLabel && <KText>{subLabel}</KText>}
      {buttonLabel && (
        <Button mt={'15px'} onClick={() => btnOnClick()} variant="primary">
          <Icon w="16px" h="16px" mr="5px" as={Plus} /> {buttonLabel}
        </Button>
      )}
    </Box>
  );
};
